var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"ma-2 black--text",staticStyle:{"opacity":"0.8"},style:(_vm.absolute ? 'position: absolute;top:6px;right:6px;' : ''),attrs:{"color":_vm.getStatusColor(_vm.event)}},[_vm._v(_vm._s(_vm.getStatus(_vm.event)))])}
var staticRenderFns = []

export { render, staticRenderFns }